import { Route } from 'react-router-dom';

import { InclusionDetailPage } from './pages/inclusion-detail-page.js';
import { InclusionFormPage } from './pages/inclusion-form-page.js';
import { InclusionListPage } from './pages/inclusion-list-page.js';

export function inclusionRoutes(): React.JSX.Element {
  return (
    <>
      <Route path="/inclusions" element={<InclusionListPage />} />
      <Route path="/inclusions/new" element={<InclusionFormPage />} />
      <Route path="/inclusions/:inclusionId/edit" element={<InclusionFormPage />} />
      <Route path="/inclusions/:inclusionId" element={<InclusionDetailPage />} />
    </>
  );
}
